import React from 'react';
import { ThemeProvider } from '@material-ui/core/styles'
import { GlobalStyle } from './styles/GlobalStyle';
import colorTheme from './styles/colorTheme';
import Routes from './routes';

function App() {
  return (
    <ThemeProvider theme={colorTheme}>
      <GlobalStyle />
      <Routes />
    </ThemeProvider>
  );
}

export default App;
